let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3TuC7")).then(() => parcelRequire('6lyud'));